import * as React from 'react';
import { useSelector } from 'react-redux';

import { NewbuildingDescription } from '../../components/NewbuildingDescription';
import { getDescription } from '../../selectors/newbuilding';

export function NewbuildingDescriptionContainer() {
  const description = useSelector(getDescription);

  if (!description) {
    return null;
  }

  return <NewbuildingDescription description={description} />;
}
